
import * as util from 'util'

import * as big from '../big'
import * as int64 from '../int64'
import * as uuid from '../uuid'

import * as fbe from '../fbe'
import * as core from '../core'
import * as inner from '../inner'

const Big = big.Big // eslint-disable-line
const Int64 = int64.Int64 // eslint-disable-line
const UInt64 = int64.UInt64 // eslint-disable-line
const UUID = uuid.UUID // eslint-disable-line
import {Account} from '../core/Account';
import {FieldModelAccount} from '../core/Account';
import {TradeHistoryRecord} from '../core/TradeHistoryRecord';
import {FieldModelTradeHistoryRecord} from '../core/TradeHistoryRecord';
import {AccountMarginStable} from '../entity/AccountMarginStable';
import {FieldModelAccountMarginStable} from '../entity/AccountMarginStable';

/**
 * Account2ResponseParams struct
 */
class Account2ResponseParams {
  /**
   * Initialize struct
   * @param {Account=} accountPrevious
   * @param {Account=} accountCurrent
   * @param {TradeHistoryRecord=} accountTradeHistoryRecord
   * @param {AccountMarginStable=} marginPrevious
   * @param {AccountMarginStable=} marginCurrent
   * @param {TradeHistoryRecord=} marginTradeHistoryRecord
   * @constructor
   */
  constructor (accountPrevious = null, accountCurrent = null, accountTradeHistoryRecord = null, marginPrevious = null, marginCurrent = null, marginTradeHistoryRecord = null) {
    this.AccountPrevious = accountPrevious
    this.AccountCurrent = accountCurrent
    this.AccountTradeHistoryRecord = accountTradeHistoryRecord
    this.MarginPrevious = marginPrevious
    this.MarginCurrent = marginCurrent
    this.MarginTradeHistoryRecord = marginTradeHistoryRecord
  }

  /**
   * Copy struct (shallow copy)
   * @this {!Account2ResponseParams}
   * @param {!Account2ResponseParams} other Other struct
   * @returns {!Account2ResponseParams} This struct
   */
  copy (other) {
    if (other.AccountPrevious != null) {
      this.AccountPrevious = Account.fromObject(other.AccountPrevious)
    } else {
      this.AccountPrevious = null
    }
    if (other.AccountCurrent != null) {
      this.AccountCurrent = Account.fromObject(other.AccountCurrent)
    } else {
      this.AccountCurrent = null
    }
    if (other.AccountTradeHistoryRecord != null) {
      this.AccountTradeHistoryRecord = TradeHistoryRecord.fromObject(other.AccountTradeHistoryRecord)
    } else {
      this.AccountTradeHistoryRecord = null
    }
    if (other.MarginPrevious != null) {
      this.MarginPrevious = AccountMarginStable.fromObject(other.MarginPrevious)
    } else {
      this.MarginPrevious = null
    }
    if (other.MarginCurrent != null) {
      this.MarginCurrent = AccountMarginStable.fromObject(other.MarginCurrent)
    } else {
      this.MarginCurrent = null
    }
    if (other.MarginTradeHistoryRecord != null) {
      this.MarginTradeHistoryRecord = TradeHistoryRecord.fromObject(other.MarginTradeHistoryRecord)
    } else {
      this.MarginTradeHistoryRecord = null
    }
    return this
  }

  /**
   * Clone struct (deep clone)
   * @this {!Account2ResponseParams}
   * @returns {!Account2ResponseParams} Cloned struct
   */
  clone () {
    // Serialize the struct to the FBE stream
    let writer = new Account2ResponseParamsModel(new fbe.WriteBuffer())
    writer.serialize(this)

    // Deserialize the struct from the FBE stream
    let reader = new Account2ResponseParamsModel(new fbe.ReadBuffer())
    reader.attachBuffer(writer.buffer)
    return reader.deserialize().value
  }

  /**
   * Is this struct equal to other one?
   * @this {!Account2ResponseParams}
   * @param {!Account2ResponseParams} other Other struct
   * @returns {boolean} Equal result
   */
  eq (other) {
    if (!(other instanceof Account2ResponseParams)) {
      throw new TypeError('Instance of Account2ResponseParams is required!')
    }
    return true
  }

  /**
   * Convert struct to JSON
   * @this {!Account2ResponseParams}
   * @returns {!object} Struct value for JSON
   */
  toJSON () {
    return {
      AccountPrevious: ((this.AccountPrevious != null) ? this.AccountPrevious : null),
      AccountCurrent: ((this.AccountCurrent != null) ? this.AccountCurrent : null),
      AccountTradeHistoryRecord: ((this.AccountTradeHistoryRecord != null) ? this.AccountTradeHistoryRecord : null),
      MarginPrevious: ((this.MarginPrevious != null) ? this.MarginPrevious : null),
      MarginCurrent: ((this.MarginCurrent != null) ? this.MarginCurrent : null),
      MarginTradeHistoryRecord: ((this.MarginTradeHistoryRecord != null) ? this.MarginTradeHistoryRecord : null)
    }
  }

  /**
   * Convert JSON to struct
   * @param {!string} json JSON string
   * @returns {!object} Struct value for JSON
   */
  static fromJSON (json) {
    return Account2ResponseParams.fromObject(JSON.parse(json))
  }

  /**
   * Create struct from object value
   * @param {!Account2ResponseParams} other Object value
   * @returns {!Account2ResponseParams} Created struct
   */
  static fromObject (other) {
    return new Account2ResponseParams().copy(other)
  }

  /**
   * Get the FBE type
   * @this {!Account2ResponseParams}
   * @returns {!number} FBE type
   */
  get fbeType () {
    return Account2ResponseParams.fbeType
  }

  /**
   * Get the FBE type (static)
   * @this {!Account2ResponseParams}
   * @returns {!number} FBE type
   */
  static get fbeType () {
    return 4153
  }
}

export { Account2ResponseParams };

/**
 * Fast Binary Encoding Account2ResponseParams field model
 */
class FieldModelAccount2ResponseParams extends fbe.FieldModel {
  /**
   * Initialize field model with the given buffer and offset
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Buffer
   * @param {!number} offset Offset
   * @constructor
   */
  constructor (buffer, offset) {
    super(buffer, offset)
    this.AccountPrevious = new fbe.FieldModelOptional(new FieldModelAccount(buffer, 4 + 4), buffer, 4 + 4)
    this.AccountCurrent = new fbe.FieldModelOptional(new FieldModelAccount(buffer, this.AccountPrevious.fbeOffset + this.AccountPrevious.fbeSize), buffer, this.AccountPrevious.fbeOffset + this.AccountPrevious.fbeSize)
    this.AccountTradeHistoryRecord = new fbe.FieldModelOptional(new FieldModelTradeHistoryRecord(buffer, this.AccountCurrent.fbeOffset + this.AccountCurrent.fbeSize), buffer, this.AccountCurrent.fbeOffset + this.AccountCurrent.fbeSize)
    this.MarginPrevious = new fbe.FieldModelOptional(new FieldModelAccountMarginStable(buffer, this.AccountTradeHistoryRecord.fbeOffset + this.AccountTradeHistoryRecord.fbeSize), buffer, this.AccountTradeHistoryRecord.fbeOffset + this.AccountTradeHistoryRecord.fbeSize)
    this.MarginCurrent = new fbe.FieldModelOptional(new FieldModelAccountMarginStable(buffer, this.MarginPrevious.fbeOffset + this.MarginPrevious.fbeSize), buffer, this.MarginPrevious.fbeOffset + this.MarginPrevious.fbeSize)
    this.MarginTradeHistoryRecord = new fbe.FieldModelOptional(new FieldModelTradeHistoryRecord(buffer, this.MarginCurrent.fbeOffset + this.MarginCurrent.fbeSize), buffer, this.MarginCurrent.fbeOffset + this.MarginCurrent.fbeSize)
  }

  /**
   * Get the field size
   * @this {!FieldModelAccount2ResponseParams}
   * @returns {!number} Field size
   */
  get fbeSize () {
    return 4
  }

  /**
   * Get the field body size
   * @this {!FieldModelAccount2ResponseParams}
   * @returns {!number} Field body size
   */
  get fbeBody () {
    return 4 + 4 + this.AccountPrevious.fbeSize + this.AccountCurrent.fbeSize + this.AccountTradeHistoryRecord.fbeSize + this.MarginPrevious.fbeSize + this.MarginCurrent.fbeSize + this.MarginTradeHistoryRecord.fbeSize
  }

  /**
   * Get the field extra size
   * @this {!FieldModelAccount2ResponseParams}
   * @returns {!number} Field extra size
   */
  get fbeExtra () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4) > this._buffer.size)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)

    let fbeResult = this.fbeBody + this.AccountPrevious.fbeExtra + this.AccountCurrent.fbeExtra + this.AccountTradeHistoryRecord.fbeExtra + this.MarginPrevious.fbeExtra + this.MarginCurrent.fbeExtra + this.MarginTradeHistoryRecord.fbeExtra

    this._buffer.unshift(fbeStructOffset)

    return fbeResult
  }

  /**
   * Get the field type
   * @this {!FieldModelAccount2ResponseParams}
   * @returns {!number} Field type
   */
  get fbeType () {
    return FieldModelAccount2ResponseParams.fbeType
  }

  /**
   * Get the field type (static)
   * @this {!FieldModelAccount2ResponseParams}
   * @returns {!number} Field type
   */
  static get fbeType () {
    return 4153
  }

  /**
   * Check if the struct value is valid
   * @this {!FieldModelAccount2ResponseParams}
   * @param {!boolean} fbeVerifyType Verify model type flag, defaults is true
   * @returns {!boolean} Field model valid state
   */
  verify (fbeVerifyType = true) {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return true
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return false
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    if (fbeStructSize < (4 + 4)) {
      return false
    }

    let fbeStructType = this.readUInt32(fbeStructOffset + 4)
    if (fbeVerifyType && (fbeStructType !== this.fbeType)) {
      return false
    }

    this._buffer.shift(fbeStructOffset)
    let fbeResult = this.verifyFields(fbeStructSize)
    this._buffer.unshift(fbeStructOffset)
    return fbeResult
  }

  /**
   * Check if the struct fields are valid
   * @this {!FieldModelAccount2ResponseParams}
   * @param {!number} fbeStructSize FBE struct size
   * @returns {!boolean} Field model valid state
   */
  verifyFields (fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AccountPrevious.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountPrevious.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountPrevious.fbeSize

    if ((fbeCurrentSize + this.AccountCurrent.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountCurrent.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountCurrent.fbeSize

    if ((fbeCurrentSize + this.AccountTradeHistoryRecord.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.AccountTradeHistoryRecord.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountTradeHistoryRecord.fbeSize

    if ((fbeCurrentSize + this.MarginPrevious.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarginPrevious.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginPrevious.fbeSize

    if ((fbeCurrentSize + this.MarginCurrent.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarginCurrent.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginCurrent.fbeSize

    if ((fbeCurrentSize + this.MarginTradeHistoryRecord.fbeSize) > fbeStructSize) {
      return true
    }
    if (!this.MarginTradeHistoryRecord.verify()) {
      return false
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginTradeHistoryRecord.fbeSize

    return true
  }

  /**
   * Get the struct value (begin phase)
   * @this {!FieldModelAccount2ResponseParams}
   * @returns {!number} Field model begin offset
   */
  getBegin () {
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructOffset = this.readUInt32(this.fbeOffset)
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + 4 + 4) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset === 0) || ((this._buffer.offset + fbeStructOffset + 4 + 4) > this._buffer.size)) {
      return 0
    }

    let fbeStructSize = this.readUInt32(fbeStructOffset)
    console.assert((fbeStructSize >= (4 + 4)), 'Model is broken!')
    if (fbeStructSize < (4 + 4)) {
      return 0
    }

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Get the struct value (end phase)
   * @this {!FieldModelAccount2ResponseParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  getEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Get the struct value
   * @this {!FieldModelAccount2ResponseParams}
   * @param {!Account2ResponseParams} fbeValue Default value, defaults is new Account2ResponseParams()
   * @returns {!Account2ResponseParams} Account2ResponseParams value
   */
  get (fbeValue = new Account2ResponseParams()) {
    let fbeBegin = this.getBegin()
    if (fbeBegin === 0) {
      return fbeValue
    }

    let fbeStructSize = this.readUInt32(0)
    this.getFields(fbeValue, fbeStructSize)
    this.getEnd(fbeBegin)
    return fbeValue
  }

  /**
   * Get the struct fields values
   * @this {!FieldModelAccount2ResponseParams}
   * @param {!Account2ResponseParams} fbeValue Account2ResponseParams value
   * @param {!number} fbeStructSize Struct size
   */
  getFields (fbeValue, fbeStructSize) {
    let fbeCurrentSize = 4 + 4

    if ((fbeCurrentSize + this.AccountPrevious.fbeSize) <= fbeStructSize) {
      fbeValue.AccountPrevious = this.AccountPrevious.get()
    } else {
      fbeValue.AccountPrevious = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountPrevious.fbeSize

    if ((fbeCurrentSize + this.AccountCurrent.fbeSize) <= fbeStructSize) {
      fbeValue.AccountCurrent = this.AccountCurrent.get()
    } else {
      fbeValue.AccountCurrent = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountCurrent.fbeSize

    if ((fbeCurrentSize + this.AccountTradeHistoryRecord.fbeSize) <= fbeStructSize) {
      fbeValue.AccountTradeHistoryRecord = this.AccountTradeHistoryRecord.get()
    } else {
      fbeValue.AccountTradeHistoryRecord = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.AccountTradeHistoryRecord.fbeSize

    if ((fbeCurrentSize + this.MarginPrevious.fbeSize) <= fbeStructSize) {
      fbeValue.MarginPrevious = this.MarginPrevious.get()
    } else {
      fbeValue.MarginPrevious = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginPrevious.fbeSize

    if ((fbeCurrentSize + this.MarginCurrent.fbeSize) <= fbeStructSize) {
      fbeValue.MarginCurrent = this.MarginCurrent.get()
    } else {
      fbeValue.MarginCurrent = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginCurrent.fbeSize

    if ((fbeCurrentSize + this.MarginTradeHistoryRecord.fbeSize) <= fbeStructSize) {
      fbeValue.MarginTradeHistoryRecord = this.MarginTradeHistoryRecord.get()
    } else {
      fbeValue.MarginTradeHistoryRecord = null
    }
    // noinspection JSUnusedAssignment
    fbeCurrentSize += this.MarginTradeHistoryRecord.fbeSize
  }

  /**
   * Set the struct value (begin phase)
   * @this {!FieldModelAccount2ResponseParams}
   * @returns {!number} Field model begin offset
   */
  setBegin () {
    console.assert(((this._buffer.offset + this.fbeOffset + this.fbeSize) <= this._buffer.size), 'Model is broken!')
    if ((this._buffer.offset + this.fbeOffset + this.fbeSize) > this._buffer.size) {
      return 0
    }

    let fbeStructSize = this.fbeBody
    let fbeStructOffset = this._buffer.allocate(fbeStructSize) - this._buffer.offset
    console.assert((fbeStructOffset > 0) && ((this._buffer.offset + fbeStructOffset + fbeStructSize) <= this._buffer.size), 'Model is broken!')
    if ((fbeStructOffset <= 0) || ((this._buffer.offset + fbeStructOffset + fbeStructSize) > this._buffer.size)) {
      return 0
    }

    this.writeUInt32(this.fbeOffset, fbeStructOffset)
    this.writeUInt32(fbeStructOffset, fbeStructSize)
    this.writeUInt32(fbeStructOffset + 4, this.fbeType)

    this._buffer.shift(fbeStructOffset)
    return fbeStructOffset
  }

  /**
   * Set the struct value (end phase)
   * @this {!FieldModelAccount2ResponseParams}
   * @param {!number} fbeBegin Field model begin offset
   */
  setEnd (fbeBegin) {
    this._buffer.unshift(fbeBegin)
  }

  /**
   * Set the struct value
   * @this {!FieldModelAccount2ResponseParams}
   * @param {!Account2ResponseParams} fbeValue Account2ResponseParams value
   */
  set (fbeValue) {
    let fbeBegin = this.setBegin()
    if (fbeBegin === 0) {
      return
    }

    this.setFields(fbeValue)
    this.setEnd(fbeBegin)
  }

  /**
   * Set the struct fields values
   * @this {!FieldModelAccount2ResponseParams}
   * @param {Account2ResponseParams} fbeValue Account2ResponseParams value
   */
  setFields (fbeValue) {
    this.AccountPrevious.set(fbeValue.AccountPrevious)
    this.AccountCurrent.set(fbeValue.AccountCurrent)
    this.AccountTradeHistoryRecord.set(fbeValue.AccountTradeHistoryRecord)
    this.MarginPrevious.set(fbeValue.MarginPrevious)
    this.MarginCurrent.set(fbeValue.MarginCurrent)
    this.MarginTradeHistoryRecord.set(fbeValue.MarginTradeHistoryRecord)
  }
}

export { FieldModelAccount2ResponseParams };

/**
 * Fast Binary Encoding Account2ResponseParams model
 */
class Account2ResponseParamsModel extends fbe.Model {
  /**
   * Initialize model with the given buffer
   * @param {!fbe.ReadBuffer|!fbe.WriteBuffer} buffer Read/Write buffer, defaults is new fbe.WriteBuffer()
   * @constructor
   */
  constructor (buffer = new fbe.WriteBuffer()) {
    super(buffer)
    this._model = new FieldModelAccount2ResponseParams(this.buffer, 4)
  }

  /**
   * Get the Account2ResponseParams model
   * @this {!Account2ResponseParamsModel}
   * @returns {!FieldModelAccount2ResponseParams} model Account2ResponseParams model
   */
  get model () {
    return this._model
  }

  /**
   * Get the model size
   * @this {!Account2ResponseParamsModel}
   * @returns {!number} Model size
   */
  get fbeSize () {
    return this.model.fbeSize + this.model.fbeExtra
  }

  /**
   * Get the model type
   * @this {!Account2ResponseParamsModel}
   * @returns {!number} Model type
   */
  get fbeType () {
    return Account2ResponseParamsModel.fbeType
  }

  /**
   * Get the model type (static)
   * @this {!Account2ResponseParamsModel}
   * @returns {!number} Model type
   */
  static get fbeType () {
    return FieldModelAccount2ResponseParams.fbeType
  }

  /**
   * Check if the struct value is valid
   * @this {!Account2ResponseParamsModel}
   * @returns {!boolean} Model valid state
   */
  verify () {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return false
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    if (fbeFullSize < this.model.fbeSize) {
      return false
    }

    return this.model.verify()
  }

  /**
   * Create a new model (begin phase)
   * @this {!Account2ResponseParamsModel}
   * @returns {!number} Model begin offset
   */
  createBegin () {
    return this.buffer.allocate(4 + this.model.fbeSize)
  }

  /**
   * Create a new model (end phase)
   * @this {!Account2ResponseParamsModel}
   * @param {!number} fbeBegin Model begin offset
   */
  createEnd (fbeBegin) {
    let fbeEnd = this.buffer.size
    let fbeFullSize = fbeEnd - fbeBegin
    this.writeUInt32(this.model.fbeOffset - 4, fbeFullSize)
    return fbeFullSize
  }

  /**
   * Serialize the struct value
   * @this {!Account2ResponseParamsModel}
   * @param {!Account2ResponseParams} value Account2ResponseParams value
   * @return {!number} Model begin offset
   */
  serialize (value) {
    let fbeBegin = this.createBegin()
    this.model.set(value)
    return this.createEnd(fbeBegin)
  }

  /**
   * Deserialize the struct value
   * @this {!Account2ResponseParamsModel}
   * @param {!Account2ResponseParams} value Account2ResponseParams value, defaults is new Account2ResponseParams()
   * @return {!object} Deserialized Account2ResponseParams value and its size
   */
  deserialize (value = new Account2ResponseParams()) {
    if ((this.buffer.offset + this.model.fbeOffset - 4) > this.buffer.size) {
      return { value: new Account2ResponseParams(), size: 0 }
    }

    let fbeFullSize = this.readUInt32(this.model.fbeOffset - 4)
    console.assert((fbeFullSize >= this.model.fbeSize), 'Model is broken!')
    if (fbeFullSize < this.model.fbeSize) {
      return { value: new Account2ResponseParams(), size: 0 }
    }

    this.model.get(value)
    return { value: value, size: fbeFullSize }
  }

  /**
   * Move to the next struct value
   * @this {!Account2ResponseParamsModel}
   * @param {!number} prev Previous Account2ResponseParams model size
   */
  next (prev) {
    this.model.fbeShift(prev)
  }
}

export { Account2ResponseParamsModel };
